export default {
  data() {
    return {
      editorMode: null,
      activeName: 'first',
      updataFragmentType: 1,
    };
  },
  mounted() {
    //获取浏览器本地存储的编辑模式
    this.getEditorMode()
  },
  methods: {
    //获取编辑模式
    getEditorMode() {
      let editorMode = localStorage.getItem('editorMode') || 'standard';
      this.editorMode = editorMode;
      this.$store.dispatch('editor/setEditorModeInfo', editorMode)
    },

    //设置编辑模式
    setEditorMode(value) {
      this.editorMode = value;
      console.log(value)
      localStorage.setItem("editorMode", value);
      this.$store.dispatch('editor/setEditorModeInfo', value);
    },

    //设置当前的id
    setCurrentId() {
      console.log(123456789)
    },

    //设置右侧显示栏目
    setLeftColumnName(name) {
      this.$store.dispatch('editor/setEditorRightActiveName', name);
    },

    //设置更新的类型
    setUpdataFragmentType(value) {
      this.updataFragmentType = value
    }
  }
};